const SELECTED_RATIO_TYPE_VOLUME = "volume";
const SELECTED_RATIO_TYPE_TICKETS = "tickets";

export { SELECTED_RATIO_TYPE_VOLUME, SELECTED_RATIO_TYPE_TICKETS };
